import { PublicClientApplication } from "@azure/msal-browser";
import { loginRequest, msalConfig } from "authConfig/authConfig";
import { msalInstance } from "msalInstance";

export const msalLogout = async () => {
  // MSAL.js v2 exposes several account APIs, logic to determine which account to use is the responsibility of the developer
  const accounts = msalInstance.getAllAccounts();
  const activeAccount = msalInstance.getActiveAccount(); // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API

  if (!activeAccount && accounts.length === 0) {
    /*
     * User is not signed in. Throw error or wait for user to login.
     * Do not attempt to log a user in outside of the context of MsalProvider
     */

    return null;
  }

  localStorage.clear();
  msalInstance.logoutRedirect({
    postLogoutRedirectUri: "/",
  });
};
